import { Component, Input, OnInit } from '@angular/core';
import { UpdateComponent } from '@app/shared/components/base/update.component';
import { DisplayName, SelectComponentOptions } from '@app/shared/components/select/base-select-with-id.component';
import { VehicleCodeUriBuilderParams, VehicleSelectionService } from '@app/core/services/vehicle-selection.service';
import { BaseList } from '@app/shared/models/list';
import { VehicleCode } from '@app/shared/models/vehicle-code';
import { VehicleManufacturer } from '@app/shared/models/vehicle-manufacturer';

@Component({
  selector: 'vehicle-type-manufacturer-select',
  templateUrl: './vehicle-type-manufacturer-select.component.html',
  styleUrls: ['./vehicle-type-manufacturer-select.component.scss']
})
export class VehicleTypeManufacturerSelectComponent extends UpdateComponent
                                                    implements OnInit {

  @Input()
  public type: string;

  @Input()
  public manufacturer: string;

  @Input()
  public vehicleTypeSelectOptions: SelectComponentOptions;

  @Input()
  public manufacturerSelectOptions: SelectComponentOptions;

  private vehicleTypes: VehicleCode[];
  private manufacturers: VehicleManufacturer[];

  private selectedVehicleTypeCode: string;

  public filteredVehicleTypes: string[];
  public filteredManufacturers: string[];

  private _vehicleTypeSelectIsOpen: boolean;
  private _manufacturerSelectIsOpen: boolean;

  set vehicleTypeSelectIsOpen(open: boolean) {
    this._vehicleTypeSelectIsOpen = open;
  }

  set manufacturerSelectIsOpen(open: boolean) {
    this._manufacturerSelectIsOpen = open;
  }

  constructor(protected vehicleSelectionService: VehicleSelectionService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();

    this.vehicleSelectionService.query(new VehicleCodeUriBuilderParams(), this.vehicleTypeSelectOptions.uriParams)
                                .subscribe((result: BaseList<VehicleCode>) => {
      this.vehicleTypes = result.items;
      this.setSelectedVehicleType(this.type);
      this.updateVehicleTypeList(this.type);
    }, err => this.handleError(err));

    this.vehicleSelectionService.queryManufacturers()
                                .subscribe((result: BaseList<VehicleManufacturer>) => {
      this.manufacturers = result.items;
      this.updateManufacturerList(this.manufacturer);
    }, err => this.handleError(err));
  }

  public getIdForSelectList(item: string): string {
    return item && typeof item === 'string' ? item.toLowerCase().replace(/\s/g, '') : item;
  }

  public updateVehicleTypeList(value: any): void {
    this.filteredVehicleTypes = this.filter(this.vehicleTypes, value);
  }

  public updateManufacturerList(value: any): void {
    this.setSelectedVehicleType(this.type);
    this.filteredManufacturers = this.filter(this.manufacturers, value, this.selectedVehicleTypeCode);
  }

  private setSelectedVehicleType(type: string): void {
    const vehicleType = this.vehicleTypes ? this.vehicleTypes.find((vC: VehicleCode) => vC.displayName === type) : null;
    if (vehicleType) {
      this.selectedVehicleTypeCode = vehicleType.code;
    } else {
      this.selectedVehicleTypeCode = type;
    }
  }

  protected filter(list: DisplayName[], value: any, type?: string): string[] {
    const filterValue = value ? value.toLowerCase() : value;
    return list.filter((option: DisplayName) => {
      const includes = option.displayName.toLowerCase().includes(filterValue);
      return type ? includes && (<VehicleManufacturer>option).belongsToVehicleTypeCode(type) : includes;
    }).map((option: DisplayName) => {
      return option.displayName;
    });
  }

  public onBlurVehicleType(override?: boolean): void {
    if (!this._vehicleTypeSelectIsOpen || override) {
      this.setSelectedVehicleType(this.type);
      this.updateManufacturerList(this.manufacturer);
      this.onChange(this.vehicleTypeSelectOptions.patchPath, this.type);
    }
  }

  public onBlurManufacturer(override?: boolean): void {
    if (!this._manufacturerSelectIsOpen || override) {
      this.onChange(this.manufacturerSelectOptions.patchPath, this.manufacturer);
    }
  }

}
